import(/* webpackMode: "eager" */ "/test-todo-app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/test-todo-app/components/sentry-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/test-todo-app/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/test-todo-app/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/test-todo-app/components/ui/tooltip.tsx");
